/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var PlayIcon = createIcon({
  name: 'PlayIcon',
  height: 512,
  width: 448,
  svgPath: 'M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default PlayIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/play-icon.js
// module id = 845
// module chunks = 0